import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const divStyle = {
  backgroundColor: '#cccccc',
}

const div2Style = {
  marginTop: '-30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'grey',
  paddingRight: '15px',
}

const linkClickStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '15px',
}

const hrStyle = {
  margin: '0px !important',
  borderTop: '0px',
}

const subtitleStyle = {
  color: '#707070',
}

const div3Style = {
  marginTop: '10px', 
  width: '30%',
  marginLeft: '313px',
  marginBottom: '10px',
}

class BarCalendar extends React.Component {
  constructor(props) {
    super(props)
  }

  loadCalendar(){
    const teams = this.props.teams
    return teams.map((team) => {
      const teamId = team.id
      const calendarId = team.calendar_id
      const calendarName = team.name
      const c = `https://calendar.google.com/calendar/u/0?cid=${calendarId}`
      return <div className="col-sm-6" key={teamId}><a href={c} target="_blank" className="btn btn-secondary btn-sm col-sm-12" style={div3Style}>{calendarName} Calendar</a></div>
    })
  }

  render() {
    const hdash = '/accounting/' + this.props.user
    const hstat = '/statistics/' + this.props.user
    const hvacations = '/myvacations/' + this.props.user
    const hcalendars = '/calendars/' + this.props.user
    
    return <Fragment><Fragment><nav className="navbar navbar-expand-lg navbar-light" style={div2Style}><div className="container"><div className="collapse navbar-collapse" style={subtitleStyle}>Accounting</div></div></nav><nav className="navbar navbar-expand-lg navbar-light" style={divStyle}><div className="container"><div className="collapse navbar-collapse"><ul className="navbar-nav mr-auto"><li className="nav-item"><a href={hdash} style={linkStyle}>Dashboard</a></li><li className="nav-item"><a href={hstat} style={linkStyle}>Statistics</a></li><li className="nav-item active"><a href={hvacations} style={linkStyle}>My vacations</a></li><li className="nav-item active"><a href={hcalendars} style={linkClickStyle}>Google Calendars</a></li></ul></div></div></nav><hr style={hrStyle} /></Fragment><Fragment>{this.loadCalendar()}</Fragment></Fragment>
  }
}

BarCalendar.propTypes = {
  user: PropTypes.string,
  teams: PropTypes.array,
}

export default BarCalendar
